// Silence all console output when running on the production domain
(function () {
	if (typeof window === 'undefined') return;
	const host = window.location.hostname;
	const shouldSilence = host === 'reward-stizen.com' || host === 'www.reward-stizen.com';
	if (!shouldSilence) return;

	const noop = () => {};
	console.log = noop;
	console.info = noop;
	console.debug = noop;
	console.warn = noop;
	console.error = noop;
})();

export {};

